// *Email Regex
export const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

// *Stripe Public Key
export const stripeKey = "pk_test_51Nnpw1BsqaVfIt5ygpIU3AIrffPEDHO0g7pJwbD0NFQrzqeyEUxKAq9vzUsqBniKit6YXKmE3eCiP1PlggqU8u3u00h3wWq7C9"
// export const stripeKey = "pk_test_51Lh6WDFOUHi2FWqBatj2mVGfXIOsa5JUMBPX0tSHCceMu4ZFor264I6OT3S5XQ5V04kAZDwnN21WuypHPlRqGPdK00M2fXCbNb"
